<app-preloader></app-preloader>
<div class="WrapperOuter" appNoRightClick>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>
